import { render } from "./WebchatLinkConfiguration.vue?vue&type=template&id=d0501b84&scoped=true&lang=pug"
import script from "./WebchatLinkConfiguration.vue?vue&type=script&lang=js"
export * from "./WebchatLinkConfiguration.vue?vue&type=script&lang=js"

import "./WebchatLinkConfiguration.vue?vue&type=style&index=0&id=d0501b84&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0501b84"]])

export default __exports__